import React from "react";

import { BlueprintSave } from "./blueprints/blueprint-save";
import { BulkEditDataAcquisition } from "./node-manager/bulk-edit-data-acquisition";
import { SnackbarNotifications } from "./snackbar-notifications/snackbar-notifications";
import { UnsavedStructure } from "./node-manager/unsaved-structure";
import { InitialStructureFilter } from "./node-manager/initial-structure-filter";
import { MachineStructureFilter } from "./node-manager/machine-structure-filter";
import { OverwriteStructure } from "./node-manager/overwrite-structure";
import { BlueprintAutoMatch } from "./blueprints/blueprint-auto-match";
import { BlueprintMyLibrary } from "./blueprints/blueprint-my-library";
import { TileDrawer } from "./blueprint-dashboards/tile-drawer/tile-drawer";
import { AlarmProfilesDrawer } from "./alarm/profiles/alarm-profiles-drawer";
import { AlarmProfileEmailRecipientsDrawer } from "./alarm/email-recipients/alarm-profile-email-recipients-drawer";
import { SourceInfoDrawer } from "./source-info/source-info-drawer";
import { AddNewGatewayDrawer } from "./add-new-gateway/add-new-gateway-drawer";
import { AddNewMachineDrawer } from "./add-new-machine/add-new-machine-drawer";
import { UnsavedStructureForNodeManagerNavigation } from "./node-manager/unsaved-structure-for-node-manager-navigation";
import { UnsavedConditionMonitoringForNodeManagerNavigation } from "./node-manager/unsaved-condition-monitoring-for-node-manager-navigation";
import { EditUserDrawer } from "./user/edit-user-drawer";
import { AddUserDrawer } from "./user/add-user-drawer";
import { AddServiceUserDrawer } from "./user/add-service-user-drawer";
import { EditServiceUserDrawer } from "./user/edit-service-user-drawer";
import { RequestRemoteMachineAccessDrawer } from "./vpn-manager/request-remote-machine-access-drawer";
import { AIRagChat } from "./ai-rag-chat/ai-rag-chat";
import { AddRequestTechnicalSupportDrawer } from "./ticket-management/add-request-technical-support-drawer";
import { SupportChat } from "./support-chat/support-chat";
import { AddRequestTechnicalSupportDrawerWithoutMachine } from "./ticket-management/add-request-technical-support-drawer-without-machine";
import { AlarmsNotificationsDrawer } from "./alarm/notifications/alarms-notifications-drawer";
import { EditWidgetDrawer } from "./widget/edit-widget-drawer";
import { WidgetPicker } from "./widget/widget-picker";

export const ModalsEntryPoint = () => {
  return (
    <div id="modals-entry-point">
      <AddNewGatewayDrawer />
      <AddNewMachineDrawer />
      <BlueprintSave />
      <BlueprintAutoMatch />
      <BlueprintMyLibrary />
      <BulkEditDataAcquisition />
      <SnackbarNotifications />
      <SourceInfoDrawer />
      <UnsavedStructure />
      <UnsavedStructureForNodeManagerNavigation />
      <UnsavedConditionMonitoringForNodeManagerNavigation />
      <OverwriteStructure />
      <InitialStructureFilter />
      <MachineStructureFilter />
      <TileDrawer />
      <AlarmProfilesDrawer />
      <AlarmProfileEmailRecipientsDrawer />
      <AddServiceUserDrawer />
      <AddUserDrawer />
      <EditUserDrawer />
      <EditServiceUserDrawer />
      <RequestRemoteMachineAccessDrawer />
      <AddRequestTechnicalSupportDrawer />
      <AddRequestTechnicalSupportDrawerWithoutMachine />
      <AIRagChat />
      <SupportChat />
      <AlarmsNotificationsDrawer />
      <EditWidgetDrawer />
      <WidgetPicker />
    </div>
  );
};
